import { create } from 'zustand';

const initialState = {
  isConnected: false,
  googleEmail: null,
  calendarId: null,
  lastSyncError: null,
  connectedAt: null,
  isLoading: false,
  isOrgEnabled: false,
};

export const useGoogleCalendarStore = create((set) => ({
  ...initialState,

  setConnectionStatus: (status) => {
    if (status?.connected) {
      localStorage.setItem('google_calendar_connected', 'true');
    } else {
      localStorage.removeItem('google_calendar_connected');
    }
    set({
      isConnected: status?.connected || false,
      googleEmail: status?.google_email || null,
      calendarId: status?.calendar_id || null,
      lastSyncError: status?.last_sync_error || null,
      connectedAt: status?.connected_at || null,
    });
  },

  setOrgEnabled: (enabled) => set({ isOrgEnabled: enabled }),

  setLoading: (loading) => set({ isLoading: loading }),

  disconnect: () => {
    localStorage.removeItem('google_calendar_connected');
    set({
      isConnected: false,
      googleEmail: null,
      calendarId: null,
      lastSyncError: null,
      connectedAt: null,
    });
  },

  reset: () => {
    localStorage.removeItem('google_calendar_connected');
    set(initialState);
  },
}));
